/**
 * Popup-mode entry point.
 *
 * Mounted at widgets.tourneynation.com/embed inside the iframe that
 * loader.js opens in a modal overlay on the organizer's site. Same
 * App component as the redirect entry; passes displayMode="popup" so
 * the chrome layer renders the modal-friendly variant (no full-page
 * background, ESC handler talks to host via postMessage).
 *
 * Posts an early "tn:registration:ready" message so loader.js knows
 * the iframe finished loading (used in production to swap out a
 * loading skeleton inside the modal box). Postmessage targets the
 * parent window with "*" because we don't know the host origin at
 * load time — the message contains no secrets, only "I'm ready."
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './styles/theme-tokens.css';
import './styles/global.css';
import './styles/skin-next.css';
import { maybeInstallStudioBridge } from './styles/studio-bridge';

maybeInstallStudioBridge();

// Same studio basename logic as main-redirect — kept for symmetry in
// case the studio is ever pointed at the popup build.
const studioMode = new URLSearchParams(window.location.search).get('studio') === '1';
const basename = studioMode ? '/preview' : undefined;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App displayMode="popup" />
    </BrowserRouter>
  </React.StrictMode>,
);

// Notify parent that the iframe finished initial render. loader.js can
// hide its loading-skeleton overlay on this signal.
try {
  window.parent.postMessage({ type: 'tn:registration:ready' }, '*');
} catch {
  // Cross-origin postMessage failure is non-fatal — loader.js falls
  // back to a timeout-based skeleton hide.
}
